<template>
  <layout name="default" class="fill-height-no-scroll">
    <v-row align="center" justify="center" class="fill-height" no-gutters>
      <v-col cols="12">
        <div class="text-uppercase text-center subtitle-2 pa-3 primary--text">
          <span>
            กรุณากรอกหมายเลขรหัส OTP ในช่องด้านล่าง
          </span>
        </div>
        <v-form ref="form" v-model="formValid" lazy-validation>
          <v-row no-gutters align="center" justify="start" class="mb-3">
            <v-col cols="12">
              <v-text-field
                v-model="otp"
                placeholder="X X X X X X"
                prepend-inner-icon="mdi-cellphone"
                type="number"
                color="primary"
                flat
                filled
                dense
                hide-details
                style="width: 80%; margin: 0 auto;"
                :rules="[
                  v =>
                    !!v ||
                    'กรุณาใส่รหัส OTP ซึ่งเป็นหมายเลข 6 หลักที่ส่งให้ทาง SMS'
                ]"
              ></v-text-field>
            </v-col>
          </v-row>
        </v-form>
        <div class="text-center">{{ diff }} วินาที</div>
        <div class="text-uppercase text-center subtitle-2 pa-3 primary--text">
          <v-btn
            small
            tile
            color="primary"
            @click="onResend()"
            :disabled="diff !== 0"
          >
            <span class="white--text">กดเพื่อส่งรหัสใหม่อีกครั้ง</span>
            <v-icon color="#fff">
              mdi-refresh
            </v-icon>
          </v-btn>
        </div>
      </v-col>
    </v-row>

    <v-footer app class="font-weight-medium pa-0">
      <v-col class="text-center pa-0" cols="4">
        <v-btn
          tile
          block
          class="pa-3"
          color="#fff"
          height="60"
          :disabled="isLoading"
          @click="onCancel()"
        >
          <span class="title secondary--text">ยกเลิก</span>
        </v-btn>
      </v-col>
      <v-col class="text-center pa-0" cols="8">
        <v-btn
          tile
          block
          class="pa-3"
          height="60"
          color="primary"
          :disabled="isLoading"
          @click="onSubmit()"
        >
          <span class="title white--text">ยืนยัน OTP</span>
        </v-btn>
      </v-col>
    </v-footer>

    <v-overlay absolute dark :value="isLoading">
      <v-progress-circular indeterminate size="48"></v-progress-circular>
    </v-overlay>
  </layout>
</template>

<script>
  import moment from 'moment';
  import regisServiec from "@/services/api/regis";
    //   import Layout from '@/layouts/layout';
//   import * as UserService from '@/services/api/users';

  export default {
    components: {
    //   Layout
    },
    data: () => ({
      isLoading: false,
      formValid: true,

      otp: null,

      timeout: moment().add(45, 'second'),
      diff: null,
      line : ""
    }),
    async created() {
         this.line = this.$store.getters.getMember;
          let checkOtp = await regisServiec.findOtp(this.line.userId);
            if (checkOtp) {
              if (checkOtp.status) {
                this.$swal("สำเร็จ", "ยืนยัน Otp เรียบร้อยแล้ว", "success");
                window.location = `line://oaMessage/@835nlrok/?`
              }
            }
    },
    computed: {
      currentBrand() {
        return this.$store.getters.currentBrand;
      },
      currentUserId() {
        return this.$store.getters.currentUserId;
      },
      currentLineUserProfile() {
        return this.$store.getters.currentLineUserProfile;
      },
      currentUser() {
        return this.$store.getters.currentUser;
      },
      firstName() {
        return this.currentUser ? this.currentUser.attributes.first_name : null;
      },
      lastName() {
        return this.currentUser ? this.currentUser.attributes.last_name : null;
      },
      email() {
        return this.currentUser ? this.currentUser.attributes.email : null;
      },
      mobilePhoneNumber() {
        return this.currentUser ? this.currentUser.attributes.mobile : null;
      }
    },
    mounted() {
      this.$refs.form.resetValidation();
      this.updateTimeout();
    },
    methods: {
      updateTimeout() {
        let currentTime = moment();

        setTimeout(() => {
          this.diff = this.timeout.diff(currentTime, 'seconds');
          if (this.diff !== 0) {
            this.updateTimeout();
          }
        }, 1000);
      },
      onCancel() {
        this.$router.push({ name: 'member' });
      },
      async onResend() {
        this.diff = 0;
        this.isLoading = true;

        // const params = {
        //   line_user_id: this.currentUserId,
        //   line_display_name: this.currentLineUserProfile.displayName,
        //   line_picture_url: this.currentLineUserProfile.pictureUrl,
        //   first_name: this.firstName,
        //   last_name: this.lastName,
        //   mobile: this.mobilePhoneNumber,
        //   acceptTermAndCondition: true
        // };

        const response = await regisServiec.createOtp(this.line.userId);
        console.log(response)
        if (response) {
          this.isLoading = false;
          this.diff = null;
          this.timeout = moment().add(45, 'second');

          this.updateTimeout();
        } else {
          this.isLoading = false;
        }
      },
      async onSubmit() {
          console.log(1234)
        this.isLoading = true;
        if (this.otp) {
            console.log(this.otp)
        //   this.formValid = true;

        //   const params = {
        //     line_user_id: this.currentUserId,
        //     line_display_name: this.currentLineUserProfile.displayName,
        //     line_picture_url: this.currentLineUserProfile.pictureUrl,
        //     first_name: this.firstName,
        //     last_name: this.lastName,
        //     mobile: this.mobilePhoneNumber,
        //     email: this.email,
        //     acceptTermAndCondition: true,
        //     otp: this.otp
        //   };
        let params = {
            lineId : this.line.userId,
            number :  this.otp.toString()
        }

          const response = await regisServiec.updateOtp(params);
        //   console.log(response)
          if (response) {
               this.$swal("สำเร็จ", "ยืนยัน Otp เรียบร้อยแล้ว", "success");
              window.location = `line://oaMessage/@835nlrok/?`
            // this.isLoading = false;
            // this.$store.commit('setUser', response.data.data);

            // this.$router.push({
            //   name: 'confirmation',
            //   query: { brand: this.currentBrand }
            // });
          } else {
             this.$swal("ไม่สำเร็จ", "กรุณาลองใหม่อีกครั้ง", "error");
            this.isLoading = false;
          }
        } else {
          this.formValid = false;
          this.isLoading = false;
        }
      }
    }
  };
</script>
